// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/monitoring/v2/aggregate.proto (package ai.h2o.mlops.monitoring.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Duration, proto3, Timestamp } from "@bufbuild/protobuf";
import { LogicalType } from "./logical_type_pb.js";

/**
 * BaselineAggregation is the entity which represent base aggregates for feature
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.BaselineAggregation
 */
export const BaselineAggregation = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.BaselineAggregation",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "column_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "logical_type", kind: "enum", T: proto3.getEnumType(LogicalType) },
    { no: 4, name: "numerical_aggregate", kind: "message", T: NumericalAggregate, oneof: "aggregate_type" },
    { no: 5, name: "categorical_aggregate", kind: "message", T: CategoricalAggregate, oneof: "aggregate_type" },
    { no: 6, name: "missing_values", kind: "message", T: MissingValues },
    { no: 7, name: "deployment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Aggregated scoring data
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.ScoringAggregation
 */
export const ScoringAggregation = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.ScoringAggregation",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "column_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "deployment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_time", kind: "message", T: Timestamp },
    { no: 5, name: "segment_duration", kind: "message", T: Duration },
    { no: 6, name: "numerical_aggregate", kind: "message", T: NumericalAggregate },
    { no: 7, name: "categorical_aggregate", kind: "message", T: CategoricalAggregate },
    { no: 8, name: "missing_values", kind: "message", T: MissingValues },
  ],
);

/**
 * Aggregated metrics specific for columns on LogicalType.LOGICAL_TYPE_NUMERICAL type.
 * Aggregated metrics are calculated for a specific time window.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.NumericalAggregate
 */
export const NumericalAggregate = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.NumericalAggregate",
  () => [
    { no: 1, name: "bin_edges", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 2, name: "bin_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 3, name: "mean", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "standard_deviation", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "max", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "sum", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * Aggregated metrics specific for columns on LogicalType.LOGICAL_TYPE_CATEGORICAL type.
 * Aggregated metrics are calculated for a specific time window.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.CategoricalAggregate
 */
export const CategoricalAggregate = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.CategoricalAggregate",
  () => [
    { no: 1, name: "value_counts", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
  ],
);

/**
 * Metrics related to missing values.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.MissingValues
 */
export const MissingValues = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.MissingValues",
  () => [
    { no: 1, name: "row_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

